import { create } from 'zustand';
import {
  AcademyEntity,
  AcademySearchFilterEntity,
  EncryptLocationEntity,
} from '@/services/types/academy.type';

interface MapState {
  centerLatitude: number;
  centerLongitude: number;
  zoomLevel: number;
}

interface AcademyListState {
  // Academy 목록 관련
  academies: AcademyEntity[];
  page: number;
  hasMore: boolean;
  /** 1페이지 실제 아이템 수(limit + isRecommend). 상세 복귀 시 prevPageCount 계산용 */
  firstPageCount: number;
  centerLocation: EncryptLocationEntity;
  search: string;
  selectedFilter: AcademySearchFilterEntity | null;
  selectedDistance: number;

  // 지도 상태
  mapState: MapState | null;

  // Actions
  setAcademies: (academies: AcademyEntity[]) => void;
  setPage: (page: number | ((prev: number) => number)) => void;
  setHasMore: (hasMore: boolean) => void;
  setCenterLocation: (location: EncryptLocationEntity) => void;
  setSearch: (search: string) => void;
  setSelectedFilter: (filter: AcademySearchFilterEntity) => void;
  setSelectedDistance: (distance: number) => void;
  setMapState: (mapState: MapState) => void;
  saveAcademyListState: (
    academies: AcademyEntity[],
    page: number,
    hasMore: boolean,
    centerLocation: EncryptLocationEntity,
    search: string,
    selectedFilter: AcademySearchFilterEntity,
    selectedDistance: number,
    firstPageCount: number,
  ) => void;
  resetAcademyListState: () => void;
  resetMapState: () => void;
}

const defaultCenterLocation: EncryptLocationEntity = {
  encryptLatitude: '',
  encryptLongitude: '',
};

export const useAcademyListStore = create<AcademyListState>()((set) => ({
  // 초기값
  academies: [],
  page: 1,
  hasMore: true,
  firstPageCount: 0,
  centerLocation: defaultCenterLocation,
  search: '',
  selectedFilter: null,
  selectedDistance: 20, // 기본 검색 범위
  mapState: null,

  // Actions
  setAcademies: (academies) => set({ academies }),
  setPage: (page) =>
    set((state) => ({
      page: typeof page === 'function' ? page(state.page) : page,
    })),
  setHasMore: (hasMore) => set({ hasMore }),
  setCenterLocation: (centerLocation) => set({ centerLocation }),
  setSearch: (search) => set({ search }),
  setSelectedFilter: (selectedFilter) => set({ selectedFilter }),
  setSelectedDistance: (selectedDistance) => set({ selectedDistance }),
  setMapState: (mapState) => set({ mapState }),

  saveAcademyListState: (
    academies,
    page,
    hasMore,
    centerLocation,
    search,
    selectedFilter,
    selectedDistance,
    firstPageCount,
  ) => {
    set({
      academies,
      page,
      hasMore,
      firstPageCount,
      centerLocation,
      search,
      selectedFilter,
      selectedDistance,
    });
  },

  resetAcademyListState: () => {
    set({
      academies: [],
      page: 1,
      hasMore: true,
      firstPageCount: 0,
    });
  },

  resetMapState: () => {
    set({ mapState: null });
  },
}));
